import React, { Component } from "react";
import styles from "./styles/Page.module.css";

export default class Page extends Component {
  render() {
    const { title, icon, padded, right, size } = this.props;

    const bodyClass = padded ? styles.bodyContPadded : styles.bodyCont;
    const contInnerClass =
      size && size === "large" ? styles.contInnerLarge : styles.contInner;

    return (
      <div className={styles.cont}>
        <div className={contInnerClass}>
          <div className={styles.headerCont}>
            <div className={styles.header}>
              <div className={styles.title}>
                {icon && <div className={styles.icon}>{icon}</div>}
                <div className={styles.titleText}>{title}</div>
              </div>
              {right && <div className={styles.right}>{right}</div>}
            </div>
          </div>
          <div className={bodyClass}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}
